import React from "react";

function Ahmedabad(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M6.68934 20.0574V15.0148C6.68934 14.3879 6.44028 13.7866 5.99695 13.3433C5.55362 12.8999 4.95234 12.6509 4.32538 12.6509C3.69842 12.6509 3.09714 12.8999 2.65381 13.3433C2.21048 13.7866 1.96143 14.3879 1.96143 15.0148V20.0574H6.68934Z"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M5.65041 20.0575V16.9981C5.66057 16.634 5.528 16.2803 5.28099 16.0125C5.03397 15.7447 4.69208 15.5841 4.32829 15.5649C3.96098 15.5787 3.614 15.7371 3.3629 16.0055C3.11181 16.2739 2.97693 16.6307 2.98765 16.9981V20.0575H5.65041Z"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M2.14624 14.1372H6.50396"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M4.26196 11.4424V12.6085"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M5.86963 8.83301H10.0264"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M6.68848 7.37842H9.30099V20.0576H6.68848V7.37842Z"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path d="M6.4563 4.50146H9.46545H6.4563Z" fill="white" />
      <path
        d="M6.4563 4.50146H9.46545"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path d="M8.07739 2.45215V3.31417V2.45215Z" fill="white" />
      <path
        d="M8.07739 2.45215V3.31417"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path d="M3.70117 13.4126V13.8742V13.4126Z" fill="white" />
      <path
        d="M3.70117 13.4126V13.8742"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path d="M4.91724 13.4126V13.8742V13.4126Z" fill="white" />
      <path
        d="M4.91724 13.4126V13.8742"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M8.73863 7.37837V3.94085C8.73863 3.76552 8.66898 3.59738 8.54501 3.47341C8.42103 3.34943 8.25289 3.27979 8.07757 3.27979C7.90224 3.27979 7.7341 3.34943 7.61012 3.47341C7.48615 3.59738 7.4165 3.76552 7.4165 3.94085V7.37837H8.73863Z"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M6.68848 11.1226H9.29835"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M9.29835 12.3784L6.68848 13.7164"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M9.29835 15.0757L6.68848 16.4137"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M9.29835 17.7729L6.68848 19.1109"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M17.3032 20.0574V15.0148C17.3032 14.3879 17.5523 13.7866 17.9956 13.3433C18.4389 12.8999 19.0402 12.6509 19.6672 12.6509C20.2941 12.6509 20.8954 12.8999 21.3387 13.3433C21.7821 13.7866 22.0311 14.3879 22.0311 15.0148V20.0574H17.3032Z"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M18.3426 20.0574V16.998C18.3284 16.8131 18.3525 16.6273 18.4135 16.4521C18.4745 16.277 18.571 16.1163 18.697 15.9803C18.823 15.8442 18.9758 15.7356 19.1457 15.6614C19.3156 15.5872 19.4991 15.5488 19.6845 15.5488C19.87 15.5488 20.0534 15.5872 20.2234 15.6614C20.3933 15.7356 20.5461 15.8442 20.6721 15.9803C20.7981 16.1163 20.8946 16.277 20.9556 16.4521C21.0166 16.6273 21.0407 16.8131 21.0265 16.998V20.0574H18.3426Z"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M21.8467 14.1372H17.489"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M19.7307 11.4424V12.6085"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M18.126 8.83252H13.9666"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M14.6936 7.37842H17.3061V20.0576H14.6936V7.37842Z"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path d="M17.5363 4.50146H14.5298H17.5363Z" fill="white" />
      <path
        d="M17.5363 4.50146H14.5298"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path d="M15.9177 2.45215V3.31417V2.45215Z" fill="white" />
      <path
        d="M15.9177 2.45215V3.31417"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path d="M20.2908 13.4126V13.8742V13.4126Z" fill="white" />
      <path
        d="M20.2908 13.4126V13.8742"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path d="M19.0754 13.4126V13.8742V13.4126Z" fill="white" />
      <path
        d="M19.0754 13.4126V13.8742"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M15.2561 7.37837V3.94085C15.2561 3.76552 15.3258 3.59738 15.4497 3.47341C15.5737 3.34943 15.7418 3.27979 15.9172 3.27979C16.0925 3.27979 16.2606 3.34943 16.3846 3.47341C16.5086 3.59738 16.5782 3.76552 16.5782 3.94085V7.37837H15.2561Z"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M17.3061 11.1226H14.6936"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M17.3035 12.3784L14.6936 13.7164"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M17.3035 15.0757L14.6936 16.4137"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M17.3035 17.7729L14.6936 19.1109"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M14.688 20.0576V11.9001C14.688 11.1854 14.4042 10.5001 13.8988 9.99476C13.3935 9.48945 12.7082 9.20557 11.9936 9.20557C11.2789 9.20557 10.5936 9.48945 10.0883 9.99476C9.58295 10.5001 9.29907 11.1854 9.29907 11.9001V20.0576H14.688Z"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M9.31763 11.5854H14.6669"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M11.9937 8.37012V9.2057"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
      <path
        d="M12.9147 20.0047V14.3936C12.9147 14.1334 12.8113 13.8839 12.6273 13.6999C12.4434 13.516 12.1938 13.4126 11.9337 13.4126C11.6735 13.4126 11.4239 13.516 11.24 13.6999C11.056 13.8839 10.9526 14.1334 10.9526 14.3936V20.0047H12.9147Z"
        stroke="#17142A"
        strokeWidth="0.351719"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

const MemoAhmedabad = React.memo(Ahmedabad);
export default MemoAhmedabad;
